import React, { useContext } from "react";
import getDisplayName from "react-display-name";
import hoistNonReactStatics from "hoist-non-react-statics";
import { NextComponentType, NextPageContext } from "next";

const HostContext = React.createContext("");

export const useHost = () => useContext(HostContext);

export const withHost = <P extends {}>(
  Page: NextComponentType<NextPageContext, {}, P>
) => {
  const WithHost = (props: P & { host?: string }) => {
    return (
      <HostContext.Provider value={props?.host || ""}>
        <Page {...props} />
      </HostContext.Provider>
    );
  };

  hoistNonReactStatics(WithHost, Page);
  WithHost.displayName = `withHost(${getDisplayName(Page)})`;

  WithHost.getInitialProps = async (ctx: NextPageContext) => {
    const headers = ctx.req?.headers;
    const host =
      (headers?.["x-forwarded-host"] as string) || headers?.host || "";

    const cleanedHost = host ? host.split(":")[0] : "";

    const pageProps = Page.getInitialProps && (await Page.getInitialProps(ctx));

    return { ...pageProps, host: cleanedHost };
  };

  return WithHost;
};
